import React from 'react';
import { useChatbot } from '../../hooks';
import FloatingChatButton from './FloatingChatButton';
import { ChatbotTemplate } from '../templates';

/**
 * ChatbotWidget - Componente principal que integra el botón flotante y la ventana de chat
 * Solo visible para usuarios con rol AGENCY_ADMIN
 */
const ChatbotWidget: React.FC = () => {
  const {
    messages,
    config,
    isLoading,
    toggleChat,
    minimizeChat,
    closeChat,
    sendMessage,
    conversations,
    isHistoryOpen,
    setIsHistoryOpen,
    selectConversation,
    createNewConversation,
    renameConversation,
    deleteConversation,
    conversationName,
    selectedConversationId,
  } = useChatbot();

  return (
    <>
      <FloatingChatButton
        onClick={toggleChat}
        isOpen={config.isOpen}
        position={config.position}
      />
      <ChatbotTemplate
        messages={messages}
        isLoading={isLoading}
        isOpen={config.isOpen}
        minimized={config.minimized}
        onSendMessage={sendMessage}
        onMinimize={minimizeChat}
        onClose={closeChat}
        position={config.position}
        title={conversationName}
        conversations={conversations}
        isHistoryOpen={isHistoryOpen}
        onShowHistory={() => setIsHistoryOpen(true)}
        onCloseHistory={() => setIsHistoryOpen(false)}
        onSelectConversation={selectConversation}
        onNewConversation={createNewConversation}
        onRenameConversation={renameConversation}
        onDeleteConversation={deleteConversation}
        selectedConversationId={selectedConversationId}
      />
    </>
  );
};

export default ChatbotWidget;

